import React from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import { useTheme, useMediaQuery } from "@material-ui/core";
import useViewer from "../../../hooks/useViewer";
import "./style.css";
import _ from "lodash";

const Footer = () => {
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));
  const { globalState } = useViewer();
  const currentYear = new Date().getFullYear();
  return (
    <>
      <Separator />
      {globalState?.eventTitle ? (
        <FooterWrapper
          style={{
            height: !isBigScreen && "auto",
            paddingTop: !isBigScreen && "5px",
          }}
          backgroundColor={
            globalState?.theme?.themeFooter?.footerBackgroundColor
          }
          borderColor={globalState?.theme?.themeFooter?.borderColor}
        >
          <Copyrights
            color={globalState?.theme?.themeFooter?.footerTextColor}
            style={{
              display: isBigScreen && "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Rights
              style={{
                justifyContent: !isBigScreen && "center",
              }}
            >
              {globalState?.advanceOptions?.copyrightText
                ? globalState?.advanceOptions?.copyrightText
                 : "All rights reserved " +currentYear}
              {globalState?.advanceOptions?.micrositePrefix ? (
                <CopyrightAddress
                  onClick={() =>
                    window.open(globalState?.advanceOptions?.micrositePrefix)
                  }
                > 
                  ({globalState?.advanceOptions?.micrositePrefix})
                </CopyrightAddress>
              ) : null}
            </Rights>

            <LogoContainer
              style={
                {
                  // display: isBigScreen ? "flex" : "inline-grid",
                  // justifyContent: !isBigScreen && "center",
                }
              }
            >
              <LogoText>Powered by</LogoText>
              {globalState?.theme?.themeFooter?.poweredByFormat === "logo" ? (
                <Logo
                  src={
                    globalState?.theme?.themeFooter?.footerLogo
                      ? globalState?.theme?.themeFooter?.footerLogo
                      : ""
                  }
                />
              ) : (
                <LogoutText
                  color={globalState?.theme?.themeFooter?.footerTextColor}
                >
                  {_.startCase(globalState?.theme?.themeFooter?.poweredBy)}
                </LogoutText>
              )}
            </LogoContainer>
          </Copyrights>
        </FooterWrapper>
      ) : null}
    </>
  );
};

export default Footer;

export const ProfileImage = styled.img``;

export const Copyrights = styled.div`
  margin: 0 0 5px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${({ color }) => (color ? color : COLORS.COLOR_DARK)};
  cursor: default;
  text-align: right;
  margin-right: 20px;
  @media (max-width: 1024px) {
    width: 100%;
    padding: 0 40px;
    text-align: right;
    margin-right: 50px;
  }
  @media ${theme?.breakpoints?.sm_up} {
    margin: 0 0 34px;
  }
`;

export const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px; 
  color: white;
  text-align: center;
  line-height: 22px;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : "#ffffff"};
  border: ${({ borderColor }) =>
    borderColor ? `1px solid ${borderColor}` : `1px solid #ffffff`}
  display: flex;
  flex-direction: column;
  justify-content: right;
  align-items: right;
  @media (max-width: 1024px) {
    height: 70px;
  }
  @media ${theme?.breakpoints?.sm_up} {
    line-height: 50px;
  }
`;

export const CompanyLogo = styled.img`
  object-fit: contain;
  width: 144px;
  height: 60px;
  cursor: pointer;

  @media (max-width: 600px) {
    width: 90px;
    height: 50px;
    object-fit: contain;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media ${theme?.breakpoints?.sm_up} {
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
  }
`;

const LogoText = styled.div`
 // font-weight: bold;
 font-size:12px;

  @media ${theme?.breakpoints?.sm_up} {
    margin-right: 5px;
    margin-bottom: 0;
  }
`;

const Logo = styled.img`
  height: 30px;

  @media ${theme?.breakpoints?.sm_up} {
    margin-right: 8px;
    margin-top: 0;
  }
`;

const Rights = styled.div`
  display: flex;
  margin-left: 5px;
  flex: 1;
  @media ${theme?.breakpoints?.sm_up} {
    margin-left: 30px;
  }
`;

const CopyrightAddress = styled.div`
  display: flex;
  font-size: 10px;
  color: #00aeef;
  cursor: pointer;
  @media ${theme?.breakpoints?.sm_up} {
    margin-left: 5px;
    flex: 1;
  }
`;

const LogoutText = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${({ color }) => (color ? color : "#293461")};
  margin-right: 36px;
  cursor: pointer;
  user-select: none;
`;

const Separator = styled.div`
 // margin-top: 100px;
  @media ${theme?.breakpoints?.sm_up} {
 //   margin-top: 100px;
  }
`;
